// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3V-SG","col":"styles_col__2dSPB"};